import { COLOR_PALETTE } from 'constants/ui';

export const ALERTS_STYLES = {
  warning: {
    color: COLOR_PALETTE.ORANGE[4],

    '&:nth-of-type(n + 2)': {
      paddingTop: 6,
    },
  },
  severe: {
    color: COLOR_PALETTE.RED[7],

    '&:nth-of-type(n + 2)': {
      paddingTop: 6,
    },
  },
};
